import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { IonicModule } from '@ionic/angular';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { MapComponent } from './map/map.component';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { environment } from 'src/environments/environment';
import { MenuBottomComponent } from './map/menu-bottom/menu-bottom.component';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './map/sidebar/sidebar.component';
import { FormsModule } from '@angular/forms';
import { GroupByPipe } from '../pipes/group-by.pipe';
import { MapStylesMenuComponent } from './map/map-styles-menu/map-styles-menu.component';
import { MapDatePickerComponent } from './map/map-date-picker/map-date-picker.component';
import { GraphComponent } from './map/graph/graph.component';
import { FieldListComponent } from './map/field-list/field-list.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { RangeSliderDateComponent } from './range-slider-date/range-slider-date.component';
import { FieldsModalComponent } from './map/fields-modal/fields-modal.component';
import { ChartJsComponent } from './chart-js/chart-js.component';
import { MultipleSelectPpopoverComponent } from './multiple-select-ppopover/multiple-select-ppopover.component';
import { FilterByPropertyPipe } from '../pipes/filter-by-property.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TreeviewModule } from '@ash-mezdo/ngx-treeview';
import { SearchDmuComponent } from './map/search-dmu/search-dmu.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterComponent } from 'src/app/admin/pages/notifications/filter/filter.component';
import { SearchComponent } from './search/search.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalRolesComponent } from 'src/app/admin/pages/user-roles/modal-roles/modal-roles.component';
import { ModalPermissionComponent } from 'src/app/admin/pages/user-roles/modal-permission/modal-permission.component';
import { NotificationsModalComponent } from './map/notifications-modal/notifications-modal.component';
import { FilterUsersComponent } from 'src/app/admin/pages/user-roles/filter/filter.component';
import { ModalConfirmationComponent } from 'src/app/admin/pages/user-roles/modal-confirmation/modal-confirmation.component';
import { LayersSelectedComponent } from './map/layers-selected/layers-selected.component';
import { DropDownComponent } from './drop-down/drop-down.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { ButtonComponent } from './button/button.component';
import { AgTableComponent } from './ag-table/ag-table.component';
import { StatusBadgeComponent } from './ag-table/components/status-badge/status-badge.component';
import { AgGridModule } from 'ag-grid-angular';
@NgModule({
  declarations: [
    MenuComponent,
    DropDownComponent,
    DynamicTableComponent,
    MapComponent,
    ModalConfirmationComponent ,
    MenuBottomComponent,
    SidebarComponent,
    ChartJsComponent,
    GroupByPipe,
    MapStylesMenuComponent,
    MapDatePickerComponent,
    GraphComponent,
    FieldListComponent,
    RangeSliderDateComponent,
    FieldsModalComponent,
    MultipleSelectPpopoverComponent,
    FilterByPropertyPipe,
    SearchDmuComponent,
    FilterComponent,
    SearchComponent,
    ModalRolesComponent,
    ModalPermissionComponent,
    NotificationsModalComponent,
    FilterUsersComponent,
    LayersSelectedComponent,
    SearchBarComponent,
    ButtonComponent,
    AgTableComponent,
    StatusBadgeComponent
  ],
  exports: [
    MenuComponent,
    DropDownComponent,
    DynamicTableComponent,
    MapComponent,
    ChartJsComponent,
    SearchComponent,
    FilterUsersComponent,
    SearchBarComponent,
    ButtonComponent,
    AgTableComponent,
    StatusBadgeComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    FormsModule,
    NgxSliderModule,
    DragDropModule,
    NgxPaginationModule,
    NgxMapboxGLModule.withConfig({
      accessToken: environment.MAPBOX_KEY, // Optional, can also be set per map (accessToken input of mgl-map)
    }),
    ScrollingModule,
    TreeviewModule.forRoot(),
    NgbTooltipModule,
    AgGridModule
  ],
})
export class ComponentsModule {}
